<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">IMPRESSUM</h3>
    <div class="informationBox">
      <ul class="useragreement">
        <li>
          <div class="t1">Information according to § 5 TMG</div>
          <p class="t2">Cardhobby Germany GmbH</p>
          <p>Luisenstraße 9, 40215 Düsseldorf</p>
          <p>Germany</p>
          <p class="t2">Contact:</p>
          <p>Phone: +49 17643383156</p>
          <p>Email: info@cardhobby.com</p>
        </li>
        <li>
          <div class="t1">Commercial Register Entry</div>
          <p>Registered in the Commercial Register</p>
          <p>Register Court: Düsseldorf</p>
          <p>Registration Number: HRB 104754</p>
        </li>
        <li>
          <div class="t1">VAT Information</div>
          <p>VAT Identification Number according to §27a UStG:<br/>DE400025761</p>
          <p>Tax Number:<br/>103/5717/5203</p>
        </li>
        <li>
          <div class="t1">Additional Information</div>
          <p>EORI Number: DE894323871983277</p>
        </li>
        
        <li>
          <div class="t1">Dispute Resolution</div>
          <p>The European Commission provides a platform for online dispute resolution (ODR):<br/>EU Online Dispute Resolution Platform</p>
          <p>We are not obligated or willing to participate in dispute resolution proceedings before a consumer arbitration board.</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
    }
  },
  mounted() {},
  created() {
    this.closeDialog()
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dislogType.login = false
      this.dislogType.register = false
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
@import "../../../static/css/information.css";

.agreementList li{
  list-style: inside;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/impressumagreement.vue